import React from 'react';

const Footer: React.FC = () => {
    return <div className='container' style={{ paddingBottom: 60 }}>
        <div className='center'>
            <h4 style={{ textAlign: "center" }}>
                Made by <a href='https://nicolasagliano.com/'>nicolasagliano.com</a>
                <br />
                P.IVA 02887470348
            </h4>
        </div>
    </div>

}

export default Footer